import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';

export default class FAQsContent extends React.Component {
    constructor(props){
        super(props);
    }
    render() {
        return(
            <div className = "col-sm-12">
                <div className="section-06 page-header" id="guides-section-06">
                    <h1 className="blog-title">FAQs</h1>
                </div>
                <div className="blog-post">
                        <li>
                            <a href="https://developers.coupang.com/hc/ko/sections/360004301613-API-%EC%9D%B8%EC%A6%9D-Key" className="mt40" target="_blank">API 인증 / Key</a>
                        </li>
                        <li>
                            <a href="https://developers.coupang.com/hc/ko/sections/360004259994-%EA%B8%B0%ED%83%80%EB%AC%B8%EC%9D%98" className="mt40" target="_blank">기타문의</a>
                        </li>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/FAQsContent.jsx